import { render, staticRenderFns } from "./PersonnelTask.vue?vue&type=template&id=9bf7e864&scoped=true"
import script from "./PersonnelTask.vue?vue&type=script&lang=js"
export * from "./PersonnelTask.vue?vue&type=script&lang=js"
import style0 from "./PersonnelTask.vue?vue&type=style&index=0&id=9bf7e864&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf7e864",
  null
  
)

export default component.exports